import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import {create_group, get_groups, clearStatus, CREATE_GROUP} from '../../redux/bases'
import MultiselectTwoSides from 'react-multiselect-two-sides';
import "./create.scss";

const CrearUsuario = () => {
    let history = useHistory();

    const crear_grupo = useSelector((store) => store.bases._create_group);
    const _get_permissions = useSelector((store) => store.bases._get_permissions);
    const { token } = useSelector((store) => store.auth);

    const [data,setData] = useState({
        nombre:'',
        permisos: [],
    });

    const [permission, setPermission] = useState([]);
    const [permissionSelect, setPermissionSelect] = useState([]);

    const [msj, setMsj] = useState("");
    const dispatch = useDispatch();

    
    useEffect(() => {
        if (crear_grupo === 200 && token) {
            dispatch(clearStatus(CREATE_GROUP, 0));
            dispatch(get_groups(token));
            history.push("/roles-permisos");
        } else if (crear_grupo === 1) {
            setMsj("Ocurrio un error al crear");

        }
    }, [crear_grupo, token, dispatch, history]);

    useEffect(() => {
        if (_get_permissions) {
            let datos = [];
            // eslint-disable-next-line
            _get_permissions.map((item) => {
                datos.push({
                    name: item.nombre,
                    value: item.codigo,
                })
            });
            setPermission(datos);
        }
    }, [_get_permissions]);

    const handleChangeMultiselect = (e) => {
        setPermissionSelect(e);
        let permisos = [];
        // eslint-disable-next-line
        e.map((item) => {
            permisos.push({codigo: item});
        })
        setData({
            ...data,
            permisos: permisos,
        });
    }

    const {nombre, permisos} = data;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!nombre || permisos.length === 0) {
            setMsj("Completa todos los campos");

        } else {
            dispatch(create_group(data, token));

        }
    };

    const canceled = () => {
        if(token){
            dispatch(get_groups(token))
        }
        dispatch(clearStatus(CREATE_GROUP, 0));
        history.push("/roles-permisos");
    }

    const onInputChange = e => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    return(
        <>
            <div className="section-header">
                <h1>Nuevo rol</h1>
            </div>

            <div className="col-12 col-md-12 col-lg-12">
                <div className="card">
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="card-header">
                            <h4>Datos del rol</h4>
                        </div>
                        {
                            msj ? (<div class="alert alert-danger m-3">
                                {msj}
                            </div>) : (null)
                        }
                        <div className="card-body row">
                            <div className="col-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <label>Nombre</label>
                                    <input type="text" name="nombre" className="form-control" required="" onChange={e => onInputChange(e)} />
                                </div>
                            </div>
                            <div className="col-12">
                                <MultiselectTwoSides
                                    options={permission}
                                    value={permissionSelect}
                                    className="msts_theme_example"
                                    onChange={handleChangeMultiselect}
                                    availableHeader="Permisos Disponibles"
                                    selectedHeader="Permisos Seleccionados"
                                    labelKey="name"
                                    showControls
                                    searchable
                                />
                            </div>
                        </div>

                        <div className="card-footer text-right">
                            <button className="btn btn-success">Guardar</button>
                            <button type="button" className="btn btn-danger" onClick={() => canceled()}>Cancelar</button>
                        </div>
                    </form>
                </div>

            </div>
        </>
    )
}

export default CrearUsuario;